module.exports = __webpack_public_path__ + "img/mydz@2x.c97b175e.png";